import applePayHelper from '../applepay/applepayhelper';
import loginForm from './loginform';
import newCustomerForm from './newcustomerform';

export default async function loginForms({ onLogin } = {}) {
    if (applePayHelper.displayApplePay) {
        document.querySelector('#nowAccepting .displayApplePay')?.classList.remove('jsHide');
    }

    loginForm.init(onLogin);
    newCustomerForm();
}